import { Button, TmdxTextarea } from '@ds';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';
import { isCommentTooLong } from '@/utils/helpers';

export type QuoteCommentModalProps = {
  actionButtonTitle: string;
  commentRequired?: boolean;
  onAction: (comment?: string) => Promise<void>;
  onClose: () => void;
};

export const QuoteCommentModal = ({
  actionButtonTitle,
  commentRequired,
  onAction,
  onClose,
}: QuoteCommentModalProps) => {
  const [comment, setComment] = useState<string | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [commentError, setCommentError] = useState<string>('');

  const onQuoteCommentValueChange = (value: string) => {
    if (commentError) setCommentError('');
    if (isCommentTooLong(value, MAX_LENGTH_2000)) {
      setCommentError(`Comment must be less than ${MAX_LENGTH_2000} characters`);
    }
    setComment(value);
  };

  const handleUpdateStatus = async () => {
    try {
      if (commentRequired && !comment) {
        setCommentError('Comment field cannot be empty');
        return;
      }

      setIsSubmitting(true);
      await onAction(comment);
      onClose();
    } catch (error) {
      toast.error('Error occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <h1 className="text-hm">Comment {`${commentRequired ? '' : '(Optional)'}`}</h1>
        <hr className="border-t-1 mt-3 mb-3 border-red" />
        <TmdxTextarea
          value={comment || ''}
          onValueChange={onQuoteCommentValueChange}
          onClear={() => {
            setComment('');
            setCommentError('');
          }}
          isInvalid={!!commentError}
          errorMessage={commentError}
          classNames={{
            inputWrapper: 'bg-base-60! rounded-lg',
          }}
          fullWidth
          disableAnimation
          maxLength={MAX_LENGTH_2000}
          minRows={5}
        />
        <hr className="border-t-1 mt-3" />
      </div>
      <div className="flex self-end gap-2 items-center">
        <Button size="sm" onPress={handleUpdateStatus} isDisabled={isSubmitting || isCommentTooLong(comment)}>
          {actionButtonTitle}
        </Button>
      </div>
    </>
  );
};
